// extracted by mini-css-extract-plugin
module.exports = {"pagination":"XZx48GcI","paginationBtn":"KyKsqqQK"};